import React from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

import { formatDateTime } from '../Utils/GlobalUtils';

import HeaderPanel from '../Components/HeaderPanel';
import Loading from '../Components/Loading';

import styles from '../styles/Inbox.module.css';

const ActivityLog = () => {
    const navigate = useNavigate();
    const [lastUserLogins, setLastUserLogins] = React.useState([]);

    const [limitForView, setLimitForView]= React.useState(10);
    const [warning, setWarning] = React.useState('');
    const [loading, setLoading] = React.useState(true);
    const [reload, setReload] = React.useState(true);

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        axios.get(`/api/last-user-logins?limitForView=${limitForView}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            if (response.data.length === 0) {
                setWarning('Записей входа нет. Хотя должны быть :/');
                setLastUserLogins([]);
            }else {
                setWarning('');
                setLastUserLogins(response.data);
            }
        })
        .catch((error) => {
            console.error(error);
            setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
        })
        .finally(() => {
            setReload(false);
            setLoading(false);
        })
    }, [reload]);

    return (
        <>
        <div className='mainContainer'>
            <h1>Действия в системе</h1>
            <HeaderPanel typePanel='Назад' />
            <div style={{marginTop: '7px'}}></div>
                <h3>Последние записи входа в систему</h3>
                {loading ? <Loading />
                : warning ? <div className='case warningLine'><a>{warning}</a></div>
                : lastUserLogins.map((lastuserlogin) => (
                    <motion.div
                        initial={{ scale: '97%', opacity: 0 }}
                        animate={{ scale: '100%', opacity: 1 }}
                        exit={{ scale: '97%', opacity: 0 }}
                        transition={{ duration: 0.3 }}
                    >
                        <div className={styles.line} key={lastuserlogin.id}>
                            <a className={styles.contentNotification} onClick={() => {navigate(`/user/${lastuserlogin.user_id}`)}} style={{cursor: 'pointer'}}>{lastuserlogin.lastname} {lastuserlogin.firstname} {lastuserlogin.surname}</a>
                            <a className={styles.contentNotification}>{lastuserlogin.email}</a>
                            <a className={styles.contentNotification}>{lastuserlogin.ip_address}</a>
                            <a className={styles.date}>{formatDateTime(lastuserlogin.login_time)}</a>
                        </div>
                    </motion.div>
                ))}
        </div>
        </>
    )
}

export default ActivityLog;